/*
 * BeeCaramulo Apiturismo - v0.1.0
 * Author: truebond.pt
 * 
 * Contact Us
 */

import { Col, Container, Row } from "react-bootstrap";

// Components
import ContactForm from "./Form";

// Styles
import "./style.scss";

function Contact(props){
    const contact = props.contact;
  
    return (
      <Container className="contact">
        <Row className="mt-5">
          <Col lg="4" data-aos="fade-right">
              <div className="info">
                <div className="address">
                  <i>{contact.location.icon}</i>
                  <h5>Morada</h5>
                  <p>{contact.location.text}</p>
                  <p>{contact.location.gps}</p>
                </div>

                <div className="email">
                  <i>{contact.email.icon}</i>
                  <h5>Email</h5>
                  <a href={contact.email.mailto}>
                    <p>{contact.email.text}</p>
                  </a>
                </div>

                <div className="phone">
                  <i>{contact.phone1.icon}</i>
                  <h5>Telefone</h5>
                  <a href={contact.phone1.tel}>
                    <p>{contact.phone1.text}</p>
                  </a>
                  <a href={contact.phone2.tel}>
                    <p>{contact.phone2.text}</p>
                  </a>
                  <p className="phone-note">Chamada para rede móvel nacional</p>
                </div>

                <div className="social">
                  {/* <i>{contact.social.icon}</i> */}
                  <h5>Redes Sociais</h5>
                  <div className="social-links mt-3">
                      <a href="https://www.facebook.com/Beecaramulo-109723241602252/" 
                         target="_blank" rel="noreferrer" className="facebook">
                           {contact.social.facebook}
                      </a>
                      {/* <a href="#" className="instagram">{contact.social.instagram}</a> */}
                  </div>
                </div>
              </div>
            </Col>

            <Col lg="8" className="mt-5 mt-lg-0" data-aos="fade-left">
              <ContactForm />
            </Col>

        </Row>
      </Container>
    );
}

export default Contact;
